import { render, staticRenderFns } from "./CodeCreate.vue?vue&type=template&id=48b8ddb0&scoped=true&"
import script from "./CodeCreate.vue?vue&type=script&lang=js&"
export * from "./CodeCreate.vue?vue&type=script&lang=js&"
import style0 from "./CodeCreate.vue?vue&type=style&index=0&id=48b8ddb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b8ddb0",
  null
  
)

export default component.exports